import { z } from 'zod/v4';

export interface IHouseNumber {
  from?: string | null;
  to?: string | null;
}

export interface IHouseNumberListRequest {
  countryCode: string;
  city: string;
  postCode: string;
  street: string;
}
export const HOUSE_NUMBER_SCHEMA: z.ZodType<IHouseNumber> = z.object({
  from: z.string().nullable().optional(),
  to: z.string().nullable().optional(),
});

export const HOUSE_NUMBERS_SCHEMA: z.ZodType<IHouseNumber[]> =
  z.array(HOUSE_NUMBER_SCHEMA);
